export enum FormStatus {
    New = 0,
    Processed = 1,
}